/**
 * Audio fade-on-skip.
 *
 * Cross-fades audio: 500ms fade-out, jump to target time, 500ms fade-in.
 * Idempotent — concurrent calls fall through to a hard seek.
 */

export function createFader(video) {
  let fading = false;

  return function fadeAndSkip(targetTime) {
    if (fading) {
      try { video.currentTime = targetTime; } catch { /* noop */ }
      return;
    }
    fading = true;
    const startVol = video.volume;
    const t0 = performance.now();

    const fadeOut = (now) => {
      const p = (now - t0) / 500;
      if (p >= 1) {
        try { video.currentTime = targetTime; } catch { /* noop */ }
        const t1 = performance.now();
        const fadeIn = (n) => {
          const q = (n - t1) / 500;
          if (q >= 1) { video.volume = startVol; fading = false; return; }
          video.volume = startVol * q;
          requestAnimationFrame(fadeIn);
        };
        requestAnimationFrame(fadeIn);
        return;
      }
      video.volume = startVol * (1 - p);
      requestAnimationFrame(fadeOut);
    };
    requestAnimationFrame(fadeOut);
  };
}
